// Frontend Academy catalog (code-defined courses)
// Keep in sync with server/academy/catalog.js

export const ACADEMY_COURSES = [
  {
    slug: 'calculo-derivadas-paso-a-paso',
    title: 'Cálculo: Derivadas paso a paso',
    description: 'Aprende derivadas guiadas por pasos: respondes cada paso hasta llegar a la solución.',
    category: 'matematicas',
    difficulty: 'Principiante',
    duration: '2 semanas',
    xpReward: 300,
    image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: true,
    units: [
      {
        id: 'derivadas-fundamentos',
        title: 'Derivadas: fundamentos',
        lessons: [
          {
            slug: 'deriva-x-cuadrado',
            title: 'Deriva x^2 (guiado)',
            duration: 6,
            xp: 30,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'Regla de potencia: la derivada de x^n es…',
                options: ['n*x^(n-1)', 'x^(n+1)', 'n*x^n', 'x^(n-1)'],
                correct_answer: 'n*x^(n-1)',
                explanation: 'La regla de potencia dice: d/dx x^n = n·x^(n-1).',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'multiple',
                prompt: 'Aplicando la regla a x^2, ¿cuál es el exponente n?',
                options: ['1', '2', '3', '0'],
                correct_answer: '2',
                explanation: 'En x^2, el exponente es n=2.',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'text',
                prompt: 'Entonces, ¿cuál es la derivada de x^2? (escribe exactamente)',
                options: null,
                correct_answer: '2x',
                explanation: 'd/dx x^2 = 2x.',
                xp: 10
              }
            ]
          },
          {
            slug: 'deriva-3x',
            title: 'Deriva 3x (guiado)',
            duration: 5,
            xp: 25,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'La derivada de ax (con a constante) es…',
                options: ['a', 'x', 'ax^2', '0'],
                correct_answer: 'a',
                explanation: 'd/dx (a·x) = a.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: 'Entonces, ¿cuál es la derivada de 3x? (escribe exactamente)',
                options: null,
                correct_answer: '3',
                explanation: 'd/dx (3x) = 3.',
                xp: 15
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'logica-puzzles',
    title: 'Lógica: Puzzles y razonamiento',
    description: 'Entrena tu razonamiento con ejercicios cortos, guiados y con explicaciones.',
    category: 'ciencias',
    difficulty: 'Principiante',
    duration: '3 semanas',
    xpReward: 400,
    image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: true,
    units: [
      {
        id: 'razonamiento-basico',
        title: 'Razonamiento básico',
        lessons: [
          {
            slug: 'falacias-identifica-error',
            title: 'Falacias: identifica el error',
            duration: 7,
            xp: 35,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: '“Todo el mundo lo hace, así que debe estar bien”. ¿Qué falacia es?',
                options: ['Ad Hominem', 'Ad Populum', 'Falsa causa', 'Hombre de paja'],
                correct_answer: 'Ad Populum',
                explanation: 'Ad Populum: asumir que algo es correcto porque es popular.',
                xp: 15
              },
              {
                step_index: 2,
                step_type: 'multiple',
                prompt: '“No le creas, es un ignorante”. ¿Qué falacia es?',
                options: ['Ad Hominem', 'Ad Populum', 'Autoridad', 'Generalización apresurada'],
                correct_answer: 'Ad Hominem',
                explanation: 'Ad Hominem: atacar a la persona en vez del argumento.',
                xp: 20
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'algebra-ecuaciones-lineales',
    title: 'Álgebra: Ecuaciones lineales',
    description: 'Aprende a resolver ecuaciones paso a paso con práctica guiada y explicaciones cortas.',
    category: 'matematicas',
    difficulty: 'Principiante',
    duration: '2 semanas',
    xpReward: 350,
    image: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: false,
    units: [
      {
        id: 'ecuaciones-basicas',
        title: 'Ecuaciones básicas',
        lessons: [
          {
            slug: 'resuelve-2x-mas-3-igual-11',
            title: 'Resuelve 2x + 3 = 11 (guiado)',
            duration: 7,
            xp: 35,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'Primer paso para despejar x en 2x + 3 = 11:',
                options: ['Restar 3 a ambos lados', 'Dividir entre 2 a ambos lados', 'Sumar 3 a ambos lados', 'Multiplicar por 2 a ambos lados'],
                correct_answer: 'Restar 3 a ambos lados',
                explanation: 'Para aislar el término con x, quita el +3 restando 3 en ambos lados.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: 'Después de restar 3, ¿qué ecuación queda? (escribe exactamente)',
                options: null,
                correct_answer: '2x=8',
                explanation: '11 - 3 = 8, así que queda 2x = 8.',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'multiple',
                prompt: 'Para obtener x en 2x = 8, debes…',
                options: ['Dividir entre 2', 'Restar 2', 'Sumar 2', 'Multiplicar por 2'],
                correct_answer: 'Dividir entre 2',
                explanation: 'Si 2x = 8, divide ambos lados entre 2 para aislar x.',
                xp: 5
              },
              {
                step_index: 4,
                step_type: 'text',
                prompt: 'Entonces, ¿cuál es el valor de x? (escribe solo el número)',
                options: null,
                correct_answer: '4',
                explanation: '8 / 2 = 4, por lo tanto x = 4.',
                xp: 10
              }
            ]
          },
          {
            slug: 'resuelve-x-menos-5-igual-12',
            title: 'Resuelve x - 5 = 12 (guiado)',
            duration: 5,
            xp: 25,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'Para despejar x en x - 5 = 12, debes…',
                options: ['Sumar 5 a ambos lados', 'Restar 5 a ambos lados', 'Multiplicar por 5 a ambos lados', 'Dividir entre 5 a ambos lados'],
                correct_answer: 'Sumar 5 a ambos lados',
                explanation: 'El -5 se elimina sumando 5 en ambos lados.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: '¿Cuál es el valor de x? (escribe solo el número)',
                options: null,
                correct_answer: '17',
                explanation: '12 + 5 = 17, así que x = 17.',
                xp: 15
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'programacion-javascript-fundamentos',
    title: 'Programación: JavaScript fundamentos',
    description: 'Variables, funciones y lógica básica con ejercicios guiados (ideal para empezar).',
    category: 'programacion',
    difficulty: 'Principiante',
    duration: '3 semanas',
    xpReward: 450,
    image: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: false,
    units: [
      {
        id: 'js-basico',
        title: 'JS básico',
        lessons: [
          {
            slug: 'variables-let-const',
            title: 'Variables: let vs const (guiado)',
            duration: 6,
            xp: 30,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: '¿Qué palabra clave usarías para una variable que NO va a reasignarse?',
                options: ['var', 'let', 'const', 'define'],
                correct_answer: 'const',
                explanation: 'Usa const cuando no planeas reasignar la variable.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: 'Escribe la palabra clave para una variable que sí se reasigna (sin espacios):',
                options: null,
                correct_answer: 'let',
                explanation: 'let permite reasignación; const no.',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'multiple',
                prompt: '¿Qué imprime este código? const x = 1; console.log(x);',
                options: ['1', 'x', 'undefined', 'error'],
                correct_answer: '1',
                explanation: 'console.log muestra el valor actual de x.',
                xp: 10
              }
            ]
          },
          {
            slug: 'funciones-return',
            title: 'Funciones: return (guiado)',
            duration: 7,
            xp: 35,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: '¿Qué hace return dentro de una función?',
                options: ['Imprime en consola', 'Devuelve un valor', 'Declara una variable global', 'Reinicia el programa'],
                correct_answer: 'Devuelve un valor',
                explanation: 'return finaliza la función y devuelve un valor al punto donde fue llamada.',
                xp: 15
              },
              {
                step_index: 2,
                step_type: 'multiple',
                prompt: 'Si una función no tiene return explícito, ¿qué devuelve?',
                options: ['null', '0', 'undefined', 'false'],
                correct_answer: 'undefined',
                explanation: 'En JavaScript, una función sin return devuelve undefined.',
                xp: 20
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'fisica-mru-fundamentos',
    title: 'Física: Movimiento Rectilíneo Uniforme (MRU)',
    description: 'Domina distancia, tiempo y velocidad con pasos guiados y ejercicios cortos.',
    category: 'ciencias',
    difficulty: 'Principiante',
    duration: '2 semanas',
    xpReward: 380,
    image: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: false,
    units: [
      {
        id: 'mru-formulas',
        title: 'MRU: fórmulas',
        lessons: [
          {
            slug: 'formula-velocidad',
            title: 'Velocidad = distancia / tiempo (guiado)',
            duration: 6,
            xp: 30,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'En MRU, la velocidad se calcula como…',
                options: ['distancia * tiempo', 'distancia / tiempo', 'tiempo / distancia', 'distancia + tiempo'],
                correct_answer: 'distancia / tiempo',
                explanation: 'La fórmula básica es v = d / t.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: 'Si recorres 100 m en 20 s, ¿cuál es la velocidad? (escribe solo el número)',
                options: null,
                correct_answer: '5',
                explanation: 'v = 100 / 20 = 5 (m/s).',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'multiple',
                prompt: 'Si mantienes la velocidad constante, la gráfica distancia-tiempo es…',
                options: ['Una recta', 'Un círculo', 'Una parábola', 'Una línea horizontal siempre'],
                correct_answer: 'Una recta',
                explanation: 'Con velocidad constante, d crece linealmente con el tiempo.',
                xp: 10
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'estadistica-probabilidad-basica',
    title: 'Estadística: Probabilidad básica',
    description: 'Conceptos esenciales con ejercicios guiados: media/mediana/moda y probabilidad simple.',
    category: 'matematicas',
    difficulty: 'Principiante',
    duration: '2 semanas',
    xpReward: 320,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: false,
    units: [
      {
        id: 'estadistica-fundamentos',
        title: 'Fundamentos',
        lessons: [
          {
            slug: 'media-mediana-moda',
            title: 'Media, mediana y moda (guiado)',
            duration: 7,
            xp: 35,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'La MEDIA (promedio) se calcula como…',
                options: ['Suma de valores / cantidad de valores', 'Valor central ordenado', 'Valor que más se repite', 'Máximo - mínimo'],
                correct_answer: 'Suma de valores / cantidad de valores',
                explanation: 'La media es el promedio: sumas y divides por el total de datos.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'multiple',
                prompt: 'La MODA es…',
                options: ['El valor que más se repite', 'El valor central', 'La suma total', 'La mitad del rango'],
                correct_answer: 'El valor que más se repite',
                explanation: 'Moda = valor más frecuente.',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'text',
                prompt: 'Datos: 2, 2, 3, 7. ¿Cuál es la moda? (escribe solo el número)',
                options: null,
                correct_answer: '2',
                explanation: 'El 2 aparece dos veces; los demás solo una.',
                xp: 15
              }
            ]
          },
          {
            slug: 'probabilidad-simple',
            title: 'Probabilidad simple (guiado)',
            duration: 6,
            xp: 30,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'Probabilidad =',
                options: ['Casos favorables / casos posibles', 'Casos posibles / casos favorables', 'Casos favorables + casos posibles', 'Casos posibles - casos favorables'],
                correct_answer: 'Casos favorables / casos posibles',
                explanation: 'P(evento) = favorables / posibles (si todos son equiprobables).',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'text',
                prompt: 'Si lanzas un dado, ¿cuál es P(sacar 6)? (escribe como fracción 1/6)',
                options: null,
                correct_answer: '1/6',
                explanation: 'Hay 1 caso favorable (6) y 6 posibles.',
                xp: 20
              }
            ]
          }
        ]
      }
    ]
  },
  {
    slug: 'tecnologia-redes-internet-basico',
    title: 'Tecnología: Redes e Internet (básico)',
    description: 'Entiende cómo viajan los datos: IP, DNS y conceptos esenciales con práctica guiada.',
    category: 'tecnologia',
    difficulty: 'Principiante',
    duration: '2 semanas',
    xpReward: 360,
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800',
    instructor: 'Graphyra',
    hasGame: true,
    featured: false,
    units: [
      {
        id: 'internet-fundamentos',
        title: 'Fundamentos de Internet',
        lessons: [
          {
            slug: 'que-es-una-ip',
            title: '¿Qué es una IP? (guiado)',
            duration: 6,
            xp: 30,
            steps: [
              {
                step_index: 1,
                step_type: 'multiple',
                prompt: 'Una dirección IP se usa para…',
                options: ['Identificar un dispositivo en una red', 'Guardar contraseñas', 'Medir la velocidad del CPU', 'Crear archivos'],
                correct_answer: 'Identificar un dispositivo en una red',
                explanation: 'La IP ayuda a enrutar paquetes hacia el destino correcto.',
                xp: 10
              },
              {
                step_index: 2,
                step_type: 'multiple',
                prompt: 'DNS sirve principalmente para…',
                options: ['Traducir nombres de dominio a IP', 'Encriptar Wi‑Fi', 'Bloquear anuncios', 'Subir videos'],
                correct_answer: 'Traducir nombres de dominio a IP',
                explanation: 'DNS resuelve dominios (ej: graphyra.com) a direcciones IP.',
                xp: 10
              },
              {
                step_index: 3,
                step_type: 'text',
                prompt: 'Si un sitio no carga por DNS, una prueba típica es hacer ping a… (escribe: IP o dominio)',
                options: null,
                correct_answer: 'IP',
                explanation: 'Hacer ping a una IP ayuda a separar problema de DNS vs conectividad.',
                xp: 10
              }
            ]
          }
        ]
      }
    ]
  }
];

export const getAcademyCourses = () => ACADEMY_COURSES;

export const getAcademyCourseBySlug = (slug) =>
  ACADEMY_COURSES.find((c) => c.slug === String(slug));

export const getAcademyLessonBySlug = (courseSlug, lessonSlug) => {
  const course = getAcademyCourseBySlug(courseSlug);
  if (!course) return null;
  for (const unit of course.units || []) {
    const lesson = (unit.lessons || []).find((l) => l.slug === String(lessonSlug));
    if (lesson) return { course, unit, lesson };
  }
  return null;
};
